export const REGEX_EMAIL =
  /(^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)|^$/
export const REGEX_PHONE_RUS = /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/
export const REGEX_SNILS = /^(([0-9]{3}-?){3}\s[0-9]{2})|([0-9]{11})$/
export const REGEX_ONLY_NUMBERS = /^[0-9]*$/
export const REGEX_BIRTHDAY_CERTIFICATE = /^[XVI]{1,3}[-\s][А-Яа-яёЁ]{2}[-\s]\d{6}$/u

export const REGEX_ONLY_NUMBERS_AND_LETTERS = /^[а-яА-ЯёЁa-zA-Z0-9\s]+$/
export const REGEX_ONLY_NUMBERS_AND_LETTERS_AND_QUESTION = /^[а-яА-ЯёЁa-zA-Z0-9\s?]+$/

export const REGEX_RUS_ONLY = /^[А-Яа-яёЁ\d\-\s,./№]+$/u

export const REGEX_AT_LEAST_ONE_NUMBER = /.*[0-9].*/
export const REGEX_AT_LEAST_ONE_UPPERCASE_LATINIC_CHAR = /(?=.*[A-Z])/
export const REGEX_AT_LEAST_ONE_LOWERCASE_LATINIC_CHAR = /(?=.*[a-z])/

export const REGEX_PASSWORD = /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])\S{8,255})$/
